var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-area',{attrs:{"title":`Setor de encaminhamento${_vm.required ? ' *' : ''}`}},[_c('Form',{attrs:{"data":_vm.data,"required":_vm.required}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }